"use client";



import { Badge } from "@/components/ui/badge";

import { Button } from "@/components/ui/button";

import { Card, CardContent } from "@/components/ui/card";

import { createServiceSlug } from "@/lib/utils/slug";

import { motion } from "framer-motion";

import { Clock, Heart, MapPin, Users } from "lucide-react";

import Image from "next/image";

import Link from "next/link";



interface ServiceCardProps {

	service: {

		id: string;

		name: string;

		description: string | null;

		duration: string;

		capacity: string;

		ageLimit: string;

		category: string;

		location: string;

		features: string[];

		image_url: string | null;

		base_price: number;

		pricing_model?: "per_participant" | "fixed_total" | "per_equipment_unit" | "per_participant_range";

		participant_pricing_ranges?: Array<{

			id: string;

			min_participants: number;

			max_participants: number;

			total_price: number;

		}>;

	};

	index: number;

	onDetailsClick: (service: any) => void;

}



export function ServiceCard({ service, index, onDetailsClick }: ServiceCardProps) {

	const serviceSlug = createServiceSlug(service.name, service.id);

	const displayPrice = () => {

		if (service.pricing_model === "per_participant_range" && service.participant_pricing_ranges?.length) {

			const prices = service.participant_pricing_ranges.map((range) => range.total_price);

			const minPrice = Math.min(...prices);

			const maxPrice = Math.max(...prices);

			if (minPrice === maxPrice) {

				return `${minPrice}€`;

			}

			return `${minPrice}€ - ${maxPrice}€`;

		}

		return `${service.base_price}€`;

	};



	return (

		<motion.div

			initial={{ opacity: 0, y: 50 }}

			animate={{ opacity: 1, y: 0 }}

			transition={{ duration: 0.6, delay: index * 0.1 }}

			whileHover={{ y: -10 }}

			className="group"

		>

			<Card className="overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-0 bg-white">

				<div className="relative overflow-hidden">

					<Image

						src={service.image_url || "/images/waterbikes_service.png"}

						alt={service.name}

						width={400}

						height={300}

						className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"

					/>

					<div className="absolute top-4 left-4">

						<Badge className="bg-white/90 text-emerald-700 font-semibold">{service.category}</Badge>

					</div>

					<div className="absolute top-4 right-4">

						<Button

							size="sm"

							variant="ghost"

							className="bg-white/90 hover:bg-white text-gray-700 rounded-full p-2"

						>

							<Heart className="w-4 h-4" />

						</Button>

					</div>

				</div>



				<CardContent className="p-6">

					<h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">

						{service.name}

					</h3>

					<p className="text-gray-600 mb-4 text-sm leading-relaxed">{service.description}</p>



					<div className="flex items-center gap-4 mb-4 text-sm text-gray-500">

						<div className="flex items-center">

							<Clock className="w-4 h-4 mr-1" />

							{service.duration}

						</div>

						<div className="flex items-center">

							<Users className="w-4 h-4 mr-1" />

							{service.capacity}

						</div>

						<div className="flex items-center">

							<MapPin className="w-4 h-4 mr-1" />

							<span className="truncate">{service.location.split(",")[0]}</span>

						</div>

					</div>



					<div className="flex items-center justify-end mb-4">

						<div className="text-sm font-medium text-emerald-600">{service.ageLimit}</div>

					</div>



					<div className="flex items-center justify-between mb-4">

						<div className="text-lg font-bold text-emerald-600">{displayPrice()}</div>

					</div>



					<div className="flex gap-2">

						<Link href={`/activites/${serviceSlug}`} className="flex-1">

							<Button

								variant="outline"

								className="w-full border-emerald-200 text-emerald-600 hover:bg-emerald-50"

							>

								Détails

							</Button>

						</Link>

						<Link href={`/activites/${serviceSlug}`} className="flex-1">

							<Button className="w-full bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white">

								Réserver

							</Button>

						</Link>

					</div>

				</CardContent>

			</Card>

		</motion.div>

	);

}

